import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const CounterIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "CounterIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M12.8286 21.9863H3.55518C2.69776 21.9863 2 21.2891 2 20.4316V8.1914C2 7.33398 2.69775 6.63671 3.55518 6.63671H4.77686C5.05323 6.63671 5.27686 6.86034 5.27686 7.13671C5.27686 7.41308 5.05323 7.63671 4.77686 7.63671H3.55518C3.24903 7.63671 3 7.88573 3 8.1914V20.4316C3 20.7373 3.24902 20.9863 3.55518 20.9863H12.8286C13.1348 20.9863 13.3838 20.7373 13.3838 20.4316V8.1914C13.3838 7.88574 13.1348 7.63671 12.8286 7.63671H11.6069C11.3306 7.63671 11.1069 7.41308 11.1069 7.13671C11.1069 6.86034 11.3306 6.63671 11.6069 6.63671H12.8286C13.686 6.63671 14.3838 7.33398 14.3838 8.1914V20.4316C14.3838 21.2891 13.686 21.9863 12.8286 21.9863Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M12.228 10.0508H4.15576C3.87939 10.0508 3.65576 9.82715 3.65576 9.55078C3.65576 9.27441 3.87939 9.05078 4.15576 9.05078H12.228C12.5044 9.05078 12.728 9.27441 12.728 9.55078C12.728 9.82715 12.5044 10.0508 12.228 10.0508Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.6069 10.0508H4.77685C4.50048 10.0508 4.27685 9.82715 4.27685 9.55078V2.51367C4.27685 2.2373 4.50048 2.01367 4.77685 2.01367H11.6069C11.8833 2.01367 12.1069 2.2373 12.1069 2.51367V9.55078C12.1069 9.82715 11.8833 10.0508 11.6069 10.0508ZM5.27685 9.05078H11.1069V3.01367H5.27685V9.05078Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.3999 14.6738H4.98388C4.70751 14.6738 4.48388 14.4502 4.48388 14.1738V11.6894C4.48388 11.4131 4.70751 11.1894 4.98388 11.1894H11.3999C11.6763 11.1894 11.8999 11.4131 11.8999 11.6894V14.1738C11.8999 14.4502 11.6763 14.6738 11.3999 14.6738ZM5.48388 13.6738H10.8999V12.1894H5.48388V13.6738Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5 19.7441H13.9111C13.6348 19.7441 13.4111 19.5205 13.4111 19.2441V9.27539C13.4111 8.99902 13.6348 8.77539 13.9111 8.77539H21.5C21.7764 8.77539 22 8.99902 22 9.27539V19.2441C22 19.5205 21.7764 19.7441 21.5 19.7441ZM14.4111 18.7441H21V9.77539H14.4111V18.7441Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M21.5 12.5H13.9111C13.6348 12.5 13.4111 12.2764 13.4111 12C13.4111 11.7236 13.6348 11.5 13.9111 11.5H21.5C21.7764 11.5 22 11.7236 22 12C22 12.2764 21.7764 12.5 21.5 12.5Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.16462 15.8847H4.49351V17.2411H6.16462V15.8847Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.02741 15.8847H7.3563V17.2411H9.02741V15.8847Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.8902 15.8847H10.2191V17.2411H11.8902V15.8847Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M6.16462 18.0043H4.49351V19.3607H6.16462V18.0043Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.02741 18.0043H7.3563V19.3607H9.02741V18.0043Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.8902 18.0043H10.2191V19.3607H11.8902V18.0043Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default CounterIcon;
